import React, { useState, useRef, useEffect } from 'react';
import { EnumConfigOption } from '@/common';
import { Button, Row, Col, Input, List, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDrag, useDrop, DropTargetMonitor } from 'react-dnd';
import './EnumConfig.css';
export type Props = {
  item: EnumConfigOption;
  index: number; 
  moveCard: (dragIndex: number, hoverIndex: number) => void;
  onRemove: (index: number) => void;
};

const DraggableItem: React.FC<Props> = ({ item, index, moveCard, onRemove }) => {
  const [editing, setEditing] = useState(false);
  const [newName, setNewName] = useState(item.name);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (item.id === null || item.id === undefined) {
      setEditing(true);
      setNewName(item.name);
    }
  }, [item.id, item.name]);
 
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'card',
    hover: (draggedItem: { index: number }, monitor: DropTargetMonitor) => {
      if (!ref.current) {
        return;
      }

      const dragIndex = draggedItem.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = (clientOffset as any).y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }

      moveCard(dragIndex, hoverIndex);
      draggedItem.index = hoverIndex;
    },
  });

  drag(drop(ref));

  const handleSave = () => {
    if(item.id == null){
      item.id = 0 - Date.now();
    } 
    item.name = newName;
    setEditing(false);
    setNewName("")
  };

  const handleCancel = () => {
    if (item.id == null) {
      onRemove(index);
      return;
    }
    setNewName(item.name);
    setEditing(false);
  };

  const deleteOption = ()=>{
    item.deleteFlag = 1;
  }

  return (
    <div ref={ref} style={{ opacity: isDragging ? 0.5 : 1 }}>
      <List.Item
        className="config-item"
        actions={[
          editing ? (
            <>
              <Button type="link" onClick={handleSave}>保存</Button>
              <Button type="link" onClick={handleCancel}>取消</Button>
            </>
          ) : (
            <>
              <Button type="link" icon={<EditOutlined />} onClick={() => setEditing(true)} />
              <Popconfirm title="确认删除此配置吗?" onConfirm={() => deleteOption()}>
                <Button type="link" icon={<DeleteOutlined />} />
              </Popconfirm>
            </>
          )
        ]}
      >
        <Row className="config-row">
          <Col span={18}>
            {editing ? (
              <Input value={newName} onChange={e => setNewName(e.target.value)} />
            ) : (
              item.name
            )}
          </Col>
        </Row>
      </List.Item>
    </div>
  );
};

export default DraggableItem;